const principles = [
  { icon: "ri-verified-badge-line", title: "来源可溯", desc: "每条瓜标注来源性质，官方回应与网传爆料一目了然。" },
  { icon: "ri-scales-3-line", title: "理性克制", desc: "不贴标签、不上升人身，对无实证信息谨慎以待。" },
  { icon: "ri-lock-2-line", title: "隐私边界", desc: "坚决不传播未经证实的恶意揣测，尊重每一位当事人。" },
  { icon: "ri-refund-line", title: "有错即改", desc: "核查不符的内容第一时间勘误下线，并对线索提供者负责。" },
];

const quotes = [
  {
    name: "追剧的北北",
    tag: "影视综艺重度用户",
    text: "以前吃瓜要在好几个 App 之间来回跳，还得猜来龙去脉。这里把时间线和背景都排好了，一条就能看明白，太省心了。",
  },
  {
    name: "夜宵配瓜的柯",
    tag: "每晚睡前必刷",
    text: "最看重它敢明确标注“网传”“待证实”，不像别处张口就来。虽然吃的是娱乐瓜，但看到有人认真核实，还是让人安心。",
  },
  {
    name: "站姐转型的安",
    tag: "娱乐行业从业者",
    text: "做宣传策划时常要盯热点，99吃瓜 的复盘和热度数据帮我省了不少调研时间，算是我每天必看的信息源之一。",
  },
];

const stats = [
  { num: "3200+", label: "累计收录话题" },
  { num: "60 万+", label: "月度阅读用户" },
  { num: "150+", label: "常驻内容栏目" },
  { num: "24h", label: "热点持续跟进" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-primary-600">
              <i className="ri-cup-line h-4 w-4 flex items-center justify-center text-accent-500" />
              ABOUT · 关于 99吃瓜
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              给每一个蹲瓜的人，一个清醒的角落
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              99吃瓜 是一群媒体人与娱乐观察者组建的资讯整理平台。我们相信热闹值得围观，
              但更需要被看清楚。因此我们不满足于搬运——而是把散落在平台各处的
              <strong className="font-semibold text-primary-700">今日瓜点</strong>、最新爆料与热门事件，
              逐一核实、标注来源、梳理成清晰的时间线与前因后果，让你点开一条就能看懂来龙去脉。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              从"塌房"复盘到热剧营销，从黄牛暗战到粉丝经济，我们用一篇篇深度长文，
              陪你看见娱乐话题背后的真实世界。热闹会散，但我们希望留给你的，
              是更理性的判断力。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200 bg-background-100/70 p-4 text-center"
                >
                  <p className="font-display text-2xl font-bold text-primary-600">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} h-5 w-5 flex items-center justify-center`} />
                  </span>
                  <div>
                    <p className="font-label text-sm font-semibold text-foreground-900">{p.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-5">
            <div className="flex items-center gap-2">
              <i className="ri-heart-3-line h-4 w-4 flex items-center justify-center text-accent-500" />
              <span className="text-sm font-semibold text-foreground-800">来自吃瓜群众的声音</span>
            </div>
            {quotes.map((q) => (
              <figure
                key={q.name}
                className="rounded-lg border border-background-200 bg-background-100/50 p-5"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill h-3.5 w-3.5 flex items-center justify-center" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{q.text}”
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-600 font-display text-sm font-bold text-background-50">
                    {q.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-900">{q.name}</span>
                    <span className="block text-xs text-foreground-500">{q.tag}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}